import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// Import required modules
import { Autoplay, Pagination } from "swiper/modules";
import { useNavigate } from "react-router-dom";

function Slider() {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/booknow");
  };

  return (
    <>
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        modules={[Autoplay, Pagination]}
        className="mySwiper"
      >
        <SwiperSlide className="sld1">
          <h1>
            Best Private theater
            <br /> in Delhi NCR
          </h1>
          <p>
            Celebrate birthdays, anniversaries, proposals, and romantic moments
            in a luxury private theater in Delhi. Located in Laxmi Nagar, enjoy
            complete privacy, elegant decor, and unforgettable cinematic
            memories with Cine Celebrate.
          </p>
          <br />

          <button onClick={handleClick}>Book Now</button>
        </SwiperSlide>
        <SwiperSlide className="sld1 sld2">
          <h2>
            Delhi’s Most Trusted <br /> Private Movie theater <br /> for
            Intimate Celebrations
          </h2>
          <p>
            If you’re searching for a private theater in Delhi that offers
            exclusivity and comfort, Cine Celebrate in Laxmi Nagar provides the
            perfect setting. Our private movie theater is designed for intimate
            celebrations where every detail matters.
          </p>
          <br />

          <button onClick={handleClick}>Book Now</button>
        </SwiperSlide>
        <div className="marquee-container">
          <div className="marquee">
            <span>CINE CELEBRATE</span>
            <span>CINE CELEBRATE</span>
            <span>CINE CELEBRATE</span>
            <span>CINE CELEBRATE</span>
            <span>CINE CELEBRATE</span>
            <span>CINE CELEBRATE</span>
            <span>CINE CELEBRATE</span>
            <span>CINE CELEBRATE</span>
            <span>CINE CELEBRATE</span>
          </div>
        </div>
      </Swiper>
    </>
  );
}

export default Slider;
